import type { BaseDataItem } from '@wix/editor-elements-definitions';
import type { CompDefinition } from '@wix/editor-elements-types/thunderbolt';
import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';

import type { VideoUploadProps } from '../VideoUpload.types';

export type VideoUploadDefinition = CompDefinition<
  never,
  VideoUploadProps & BaseDataItem,
  never,
  never
>;

export const props = withCompInfo<VideoUploadProps, VideoUploadDefinition>()(
  ['compData'],
  ({ compData }) => compData,
);

export default createComponentMapperModel({ props });
